import { Component } from 'react'

class ChatContainer extends Component {
  UNSAFE_componentWillMount() {
    if (import.meta.env.VITE_REACT_APP_ENV === 'PRODUCTION') {
      return window.location.replace('https://workplace.meetingdoctors.com')
    }

    return window.location.replace('https://workplace.dev.meetingdoctors.com')
  }

  render() {
    return null
  }
}

export default ChatContainer
